import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService } from 'mapfre-auditlib';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class VisibilityService {

  className = 'VisibilityService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllVisibilityRules(cache = true, cacheKey = "allVisibilityRules"): Observable<any[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/visibility-rule-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newVisibilityRule(rule) {
    return this.http.post(environment.base_URL + "/visibility-rule-types", rule)
  }

  updateVisibilityRule(rule, id) {
    return this.http.put(environment.base_URL + `/visibility-rule-types/${id}`, rule)
  }

  deleteVisibilityRule(id) {
    return this.http.delete(environment.base_URL + `/visibility-rule-types/${id}`)
  }

  getAllUserVisibility(cache = true, cacheKey = "allUserVisibility"): Observable<any[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/user-visibility-rule-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newVisibilityUser(rule, user) {
    return this.http.post(environment.base_URL + `/user-visibility-rule-types?userId=${user}`, rule)
  }

  updateVisibilityUser(rule, id) {
    return this.http.put(environment.base_URL + `/user-visibility-rule-types/${id}`, rule)
  }

  deleteVisibilityUser(id) {
    return this.http.delete(environment.base_URL + `/user-visibility-rule-types/${id}`)
  }
}